module.exports = __webpack_public_path__ + "static/lemonanimal5-9eabb977e3c68315e75c6d8593d072c6.png";